<template>
<div class="chapter">
<div class="inner_page">
<div class="sidebar"><a id="file_032"></a><a id="page_14">
<p class="sidebartitle"><strong>MATERIALS</strong></p>
<p class="bulitlist">• 0.07 oz. (2 g) red wool</p>
<p class="bulitlist">• 0.07 oz. (2 g) black wool</p>
<p class="bulitlist">• small amount of yellow and white wool</p>
<p class="bulitlist">• craft glue</p>
<p class="bulitlist">• small rare earth magnet</p>
<p class="bulitlist">• beads for eyes</p>
<p class="bulitlist">• beading needle and thread</p>
<p class="bulitlist">• felting needle</p>
<p class="bulitlist">• foam pad</p>
<p class="bulitlist">• ruler</p>
</a></div><a id="page_14">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_032.vue?45212216